module.exports = __webpack_public_path__ + "img/servicesStepTwo.7cc414e4.webp";